<template>
  <page-content>
    <v-toolbar flat v-if="normalizedTabs.length > 1">
      <app-tabs>
        <v-tab v-for="tab of normalizedTabs" :key="tab.id" :to="'#' + tab.id">
          {{ tab.name }}
        </v-tab>
      </app-tabs>
      <create-btn icon="mdi-bell-plus" text="Utwórz" tooltip="Nowe zdarzenie" @click="onNewEvent"></create-btn>
      <toolbar-btn :disabled="!isFiltered" icon="mdi-filter-off" tooltip="Wyczyść filtry" @click="resetFilters" />
      <toolbar-btn :disabled="count === 0" icon="mdi-cloud-download-outline" tooltip="Zapis do pliku" @click="onDownload()" />
    </v-toolbar>
    <v-divider></v-divider>
    <app-toolbar justify="end">
      <v-col>
        <app-filter-field label="" v-model="filter" @input="onFilter"></app-filter-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-select outlined dense return-object hide-details v-model="categorySelected" :items="categories"
          :item-text="(item) => item.name" label="Kategoria">
        </v-select>
      </v-col>
      <v-col cols="12" md="3">
        <date-range-editor :items="ranges" v-model="rangeSelected"></date-range-editor>
      </v-col>
      <v-col cols="12" md="3" v-if="sortBy.length > 1">
        <app-sort-select v-model="sortBySelected" :items="sortBy" :item-text="(item) => item.name"></app-sort-select>
      </v-col>
    </app-toolbar>
    <v-col cols="12" v-for="(event, index) of events" :key="event.id || `event-${index}`" dense class="pa-1">
      <event-card-responsive :siteHidden="siteHidden" :event="event" :change-flags="eventSignalById[event.id]" class="" />
    </v-col>
    <v-card-actions class="justify-center">
      <!-- <v-row dense align="center"> -->
        <v-col>Ilość: <v-chip v-if="count > 0" small class="ml-3">{{ count }}</v-chip></v-col>
      <!-- </v-row> -->
      <v-pagination v-if="pages > 1" v-model="page" :length="pages" circle :total-visible="3"></v-pagination>
    </v-card-actions>
  </page-content>
</template>

<script>

import EventService from "@/services/event.service"
import { Labels } from "@/store/modules/task"

export default {
  name: "SiteEvents",
  data() {
    return {
      timer: null,
      categorySelected: this.categories[0],
      sortBySelected: null, // TaskService.getTaskOrdering()[0],
      rangeSelected: null, //TaskService.getTaskRanges()[0],
      filter: "",
      page: 1,
      created: false
    }
  },
  props: {
    tabs: {
      type: Array,
      default: () => EventService.getMainConditions()
    },
    categories: {
      type: Array,
      default: () => EventService.getCategoryConditions()
    },
    sortBy: {
      type: Array,
      default: () => EventService.getEventOrdering()
    },
    ranges: {
      type: Array,
      default: () => EventService.getEventRanges()
    },
    pages: {
      type: Number,
      default: () => 0
    },
    count: {
      type: Number,
      default: () => 0
    },
    extraConditions: {
      type: Array,
      default: () => []
    },
    events: {
      type: Array,
      default: () => []
    },
    eventSignalById: {
      type: Object,
      default: () => ({})
    },
    siteHidden: {
      type: Boolean,
      default: null
    }
  },
  watch: {
  },
  computed: {
    normalizedTabs() {
      if (!Array.isArray(this.tabs)) {
        return []
      }
      return this.tabs.filter(tab => tab && tab.id)
    },
    selectedTab() {
      const hash = this.$route.hash.replace(/^#/, '')
      return this.normalizedTabs.find(t => t.id === hash)?.id ?? this.normalizedTabs[0]?.id
    },
    normalizedEvents() {
      if (!Array.isArray(this.events)) {
        return []
      }
      return this.events.filter(event => event != null)
    },
    isFiltered() {
      return !!(
        this.filter ||
        this.categorySelected?.id !== this.categories[0]?.id ||
        this.rangeSelected?.id !== this.ranges[0]?.id ||
        this.page > 1
      )
    }
  },
  methods: {
    onFilter() {
      this.refresh()
    },
    getTab(tabId = this.selectedTab) {
      return this.normalizedTabs.find(tab => tab.id == tabId) ?? this.normalizedTabs[0] ?? null
    },
    getSortOption(ordering) {
      return this.sortBy.find(item => item.ordering == ordering) ?? this.sortBy[0]
    },
    getTabDefaultOrdering(tabId = this.selectedTab) {
      return this.getTab(tabId)?.defaultOrdering ?? this.sortBy[0]?.ordering
    },
    onNewEvent() {
      this.$router.push({
        name: "New Event"
      })
    },
    onDownload() {
      this.$emit("download-request", this.createRefreshContext())
    },
    createRefreshContext() {
      var range = { range: this.rangeSelected.id }
      if (this.rangeSelected.id == 'custom') {
        range = {
          range: this.rangeSelected.id,
          from: this.rangeSelected.from,
          to: this.rangeSelected.to
        }
      }
      var query = {
        ...this.getTab(this.selectedTab)?.params,
        ...range,
        ...this.categorySelected.params,
        page: `${this.page}`,
        ordering: this.sortBySelected?.ordering ?? this.getTabDefaultOrdering(this.selectedTab)
      }
      if (this.filter) {
        query.search = this.filter
      }

      if (JSON.stringify(query) != JSON.stringify(this.$route.query)) {
        this.$router.replace({
          path: this.$route.path,
          query: query,
          hash: this.$route.hash
        })
      }

      // Save to localStorage for hybrid state restoration (only non-dashboard tabs)
      if (!this.getTab(this.selectedTab)?.isDashboard) {
        try {
          localStorage.setItem('events:lastContext', JSON.stringify({
            filter: this.filter || '',
            categoryId: this.categorySelected?.id,
            ordering: this.sortBySelected?.ordering,
            rangeId: this.rangeSelected?.id,
            rangeFrom: this.rangeSelected?.from,
            rangeTo: this.rangeSelected?.to,
            page: this.page,
            tab: this.selectedTab,
          }))
        } catch (e) { /* ignore */ }
      }

      return {
        page: this.page,
        query: query,
        filter: this.filter,
        category: this.categorySelected,
        range: this.rangeSelected,
        ordering: this.sortBySelected?.ordering,
        tab: this.selectedTab
      }
    },
    refresh() {
      this.$emit("refresh-request", this.createRefreshContext())
    },
    resetFilters() {
      try {
        localStorage.removeItem('events:lastContext')
        localStorage.removeItem('events:scrollY')
      } catch (e) { /* ignore */ }
      this.filter = ''
      this.categorySelected = this.categories[0]
      this.sortBySelected = this.getSortOption(this.getTabDefaultOrdering())
      this.rangeSelected = this.ranges[0]
      this.page = 1
    },
    icon(status) {
      return Labels.get(status.label_id).icon
    },
    color(status) {
      const x = `${Labels.get(status.label_id).color(this.$vuetify.theme.dark) }`.split(" ")
      return `${x[0]}--text text--${x[1]}`
    }
  },
  beforeMount() {
    const query = this.$route.query
    const hash = this.$route.hash.replace(/^#/, '')
    let targetHash = hash
    const queryCategory = query.category

    // URL has meaningful context if it contains any filter param or a valid tab hash
    const hasUrlContext = !!(
      query.state || query.range || query.ordering ||
      query.search || (query.page && parseInt(query.page, 10) > 1) || queryCategory ||
      (hash && this.normalizedTabs.find(t => t.id === hash))
    )

    let restored = false
    if (!hasUrlContext) {
      try {
        const saved = localStorage.getItem('events:lastContext')
        if (saved) {
          const ctx = JSON.parse(saved)
          this.filter = ctx.filter || ''
          this.categorySelected = this.categories.find(c => c.id === ctx.categoryId) ?? this.categories[0]
          this.sortBySelected = this.getSortOption(ctx.ordering)
          const savedRange = this.ranges.find(r => r.id === ctx.rangeId) ?? this.ranges[0]
          this.rangeSelected = savedRange.id === 'custom'
            ? { ...savedRange, from: ctx.rangeFrom, to: ctx.rangeTo }
            : savedRange
          this.page = ctx.page || 1
          if (ctx.tab) {
            targetHash = ctx.tab
            this.$router.replace({ path: this.$route.path, hash: '#' + ctx.tab })
          }
          restored = true
        }
      } catch (e) { /* ignore */ }
    }

    if (!restored) {
      // Hydrate from URL
      const initialOrdering = query.ordering ?? this.getTabDefaultOrdering()
      this.filter = query.search || ''
      this.categorySelected = this.categories.find(c =>
        c.id == queryCategory || c.params?.category == queryCategory
      ) ?? this.categories[0]
      this.sortBySelected = this.getSortOption(initialOrdering)
      this.page = parseInt(query.page, 10) || 1

      let range = this.ranges[0]
      if (query.range) {
        range = this.ranges.find(c => c.id == query.range) ?? this.ranges[0]
      } else if (query.from) {
        range = this.ranges.find(c => c.id === 'custom') ?? this.ranges[0]
      }
      if (range.id === 'custom') {
        range = { ...range, from: query.from, to: query.to }
      }
      this.rangeSelected = range

      // Derive hash from query.state when hash is absent (support pasted URLs like ?state=closed)
      if (query.state && !hash) {
        const matchingTab = this.normalizedTabs.find(t => t.params?.state === query.state)
        if (matchingTab) {
          targetHash = matchingTab.id
          this.$router.replace({
            path: this.$route.path,
            query: this.$route.query,
            hash: '#' + matchingTab.id
          })
        }
      }
    }

    // Canonicalize Events URL: always keep an explicit tab hash
    if (!targetHash && this.normalizedTabs[0]?.id) {
      targetHash = this.normalizedTabs[0].id
      this.$router.replace({
        path: this.$route.path,
        query: this.$route.query,
        hash: '#' + targetHash
      })
    }

    // Set up watchers AFTER initializing values to avoid spurious initial refreshes
    const watches = ['page', 'sortBySelected', 'rangeSelected', 'categorySelected', 'filter']
    watches.forEach((watch) => {
      this.$watch(watch, () => {
        this.refresh()
      })
    })
    this.$watch('selectedTab', (value, oldValue) => {
      if (value === oldValue) {
        return
      }

      const nextOrdering = this.getTabDefaultOrdering(value)
      const previousOrdering = this.getTabDefaultOrdering(oldValue)

      this.sortBySelected = this.getSortOption(nextOrdering)
      // sortBySelected watcher will call refresh(); if ordering didn't change, trigger manually
      if (nextOrdering === previousOrdering) {
        this.refresh()
      }
    })
    // Restore scroll position after first data load (set by EventCardResponsive on navigate away)
    const savedScrollY = parseInt(localStorage.getItem('events:scrollY'), 10)
    if (Number.isFinite(savedScrollY) && savedScrollY > 0) {
      const scrollUnwatch = this.$watch('events', (events) => {
        if (Array.isArray(events)) {
          this.$nextTick(() => {
            if (events.length > 0) {
              window.scrollTo({ top: savedScrollY, behavior: 'auto' })
            }
            try { localStorage.removeItem('events:scrollY') } catch (e) { /* ignore */ }
            scrollUnwatch()
          })
        }
      })
    }

    this.$nextTick(() => this.refresh())
    this.timer = setInterval(this.refresh, 10000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>
